import React from 'react';
import { Table } from 'reactstrap';
import { displayValue } from '../../../../TenderOpening/utils/tenderOpeningHelpers';

const formatQty = (value, unitLabel) => {
  const resolved = displayValue(value);
  return resolved !== '-' ? `${resolved} ${unitLabel}` : '-';
};

// Alpha HPS belum tentu sudah diisi; pertahankan label "Requested" seperti sebelumnya
// untuk sel yang masih kosong, dan tampilkan angkanya begitu tersedia.
const alphaCell = value =>
  value === null || value === undefined || value === '' ? 'Requested' : value;

const ParcelIncotermTable = ({
  rows,
  quantityUnitLabel = 'MB',
  usesDyedUndyed = true,
  alphaColumnLabel = 'Alpha',
}) => {
  if (!rows?.length) {
    return <p className='text-muted small mb-0'>No incoterm data available.</p>;
  }

  return (
    <div className='table-responsive'>
      <Table bordered size='sm' className='mb-0'>
        <thead className='bg-light'>
          <tr>
            <th className='fw-semibold small text-dark'>Parcel Size</th>
            <th className='fw-semibold small text-dark'>Incoterm</th>
            <th className='fw-semibold small text-dark'>Routes</th>
            <th className='fw-semibold small text-dark'>Loading Port</th>
            <th className='fw-semibold small text-dark'>Discharge Qty 1</th>
            <th className='fw-semibold small text-dark'>Port 1</th>
            <th className='fw-semibold small text-dark'>ALD/ADD</th>
            <th className='fw-semibold small text-dark'>Discharge Qty 2</th>
            <th className='fw-semibold small text-dark'>Port 2</th>
            <th className='fw-semibold small text-dark'>ALD/ADD</th>
            <th className='fw-semibold small text-dark'>Discharge Qty 3</th>
            <th className='fw-semibold small text-dark'>Port 3</th>
            <th className='fw-semibold small text-dark'>ALD/ADD</th>
            <th className='fw-semibold small text-dark'>
              {usesDyedUndyed ? 'Alpha Dyed' : alphaColumnLabel}
            </th>
            {usesDyedUndyed && (
              <th className='fw-semibold small text-dark'>Alpha Undyed</th>
            )}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <tr key={index}>
              <td className='small text-dark'>
                {formatQty(row.deliveryBasis, quantityUnitLabel)}
              </td>
              <td className='small text-dark'>{displayValue(row.incoterm)}</td>
              <td className='small text-dark'>{displayValue(row.route)}</td>
              <td className='small text-dark'>
                {displayValue(row.loadingPort)}
              </td>
              <td className='small text-dark'>
                {formatQty(row.dischargeQty1, quantityUnitLabel)}
              </td>
              <td className='small text-dark'>{displayValue(row.port1)}</td>
              <td
                className='small text-dark text-wrap'
                style={{ maxWidth: '90px' }}
              >
                {displayValue(row.aldAdd1)}
              </td>
              <td className='small text-dark'>
                {formatQty(row.dischargeQty2, quantityUnitLabel)}
              </td>
              <td className='small text-dark'>{displayValue(row.port2)}</td>
              <td
                className='small text-dark text-wrap'
                style={{ maxWidth: '90px' }}
              >
                {displayValue(row.aldAdd2)}
              </td>
              <td className='small text-muted'>
                {formatQty(row.dischargeQty3, quantityUnitLabel)}
              </td>
              <td className='small text-muted'>{displayValue(row.port3)}</td>
              <td
                className='small text-muted text-wrap'
                style={{ maxWidth: '90px' }}
              >
                {displayValue(row.aldAdd3)}
              </td>
              {usesDyedUndyed ? (
                <>
                  <td className='small text-muted'>
                    {displayValue(alphaCell(row.alphaDyedHps))}
                  </td>
                  <td className='small text-muted'>
                    {displayValue(alphaCell(row.alphaUndyedHps))}
                  </td>
                </>
              ) : (
                <td className='small text-muted'>
                  {displayValue(
                    alphaCell(row.alphaHps ?? row.hpsAlpha ?? row.alpha ?? null)
                  )}
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default ParcelIncotermTable;
